export const highlightText = (text: string, searchTerm: string) => {
  const span = document.createElement("span");

  if (!searchTerm) {
    span.textContent = text;
    return span;
  }

  const lowerText = text.toLowerCase();
  const lowerSearch = searchTerm.toLowerCase();
  const matchIndex = lowerText.indexOf(lowerSearch);

  if (matchIndex === -1) {
    span.textContent = text;
    return span;
  }

  const before = text.slice(0, matchIndex);
  const match = text.slice(matchIndex, matchIndex + searchTerm.length);
  const after = text.slice(matchIndex + searchTerm.length);

  if (before) span.appendChild(document.createTextNode(before));

  const highlight = document.createElement("span");
  highlight.textContent = match;
  // highlight.style.backgroundColor = colors.yellow;
  highlight.style.fontWeight = "800";
  highlight.style.borderRadius = "2px";
  span.appendChild(highlight);

  if (after) span.appendChild(document.createTextNode(after));

  return span;
};
